import { useAuthToken } from '@shared/stores/authToken'

import { usePermissions } from './usePermissions'

const isProduction = import.meta.env.VITE_APP_URL.includes('prod')

export const configs = {
  TRANSFERBANK: {
    platformUrlRedirection: isProduction
      ? 'https://admin.transferbank.com.br'
      : 'https://admin-stag.transferbank.com.br',
    acceptedUrls: [
      'https://admin.transferbank.com.br',
      'https://admin-stag.transferbank.com.br'
      // 'http://localhost'
    ],
    platformOnboardingUrl: isProduction
      ? 'https://onboarding.transferbank.com.br/'
      : 'https://onboarding-stag.transferbank.com.br/',
    institution: 'TRANSFERBANK',
    key: 'TRANSFERBANK',
    tag: 'TFB',
    color: '#0AA092',
    isApp: true
  },
  FX55: {
    platformUrlRedirection: isProduction
      ? 'https://admin.fx55.com.br'
      : 'https://admin-stag.fx55.com.br',
    acceptedUrls: [
      'https://admin.fx55.com.br',
      'https://admin-stag.fx55.com.br',
      'http://localhost'
    ],
    platformOnboardingUrl: isProduction
      ? 'https://onboarding.fx55.com.br'
      : 'https://onboarding-stag.fx55.com.br',
    institution: 'TRANSFERBANK',
    key: 'FX55',
    tag: 'TFB',
    color: '#0AA092',
    isApp: true
  },
  DOURADA: {
    platformUrlRedirection: isProduction
      ? 'https://admin.dourada.com.br'
      : 'https://admin-dourada-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://admin.dourada.com.br',
      'https://admin-dourada-stag.transferbankfx.com.br',
      'https://admin-dourada.transferbankfx.com.br'
    ],
    platformOnboardingUrl: isProduction
      ? 'https://onboarding.dourada.com.br/'
      : 'https://onboarding-stag.dourada.com.br/',
    institution: 'DOURADA',
    key: 'DOURADA',
    tag: 'DOU',
    color: '#EFC132'
  },
  SVN: {
    platformUrlRedirection: isProduction
      ? 'https://admin-svn.transferbankfx.com.br'
      : 'https://admin-svn-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://admin-svn.transferbankfx.com.br',
      'https://admin-svn-stag.transferbankfx.com.br'
    ],
    platformOnboardingUrl: isProduction
      ? 'https://onboarding-svn.transferbankfx.com.br'
      : 'https://onboarding-svn-stag.transferbankfx.com.br',
    institution: 'SVN',
    key: 'SVN',
    tag: 'SVN',
    color: '#BB9F8B'
  },
  MIRAE: {
    platformUrlRedirection: isProduction
      ? 'https://admin-transferbank.miraeinvest.com.br'
      : 'https://admin-mirae-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://admin-transferbank.miraeinvest.com.br',
      'https://admin-mirae-stag.transferbankfx.com.br',
      'https://admin-mirae.transferbankfx.com.br'
    ],
    platformOnboardingUrl: isProduction
      ? 'https://onboarding-mirae.transferbankfx.com.br/'
      : 'https://onboarding-mirae-stag.transferbankfx.com.br/',
    institution: 'MIRAE',
    key: 'MIRAE',
    tag: 'MIR',
    color: '#F58220',
    isApp: true
  },
  NORD: {
    platformUrlRedirection: isProduction
      ? 'https://admin-cambio.nordinvestimentos.com.br'
      : 'https://admin-nord-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://admin-cambio.nordinvestimentos.com.br',
      'https://admin-nord-stag.transferbankfx.com.br',
      'https://admin-nord.transferbankfx.com.br'
    ],
    platformOnboardingUrl: isProduction
      ? 'https://onboarding-cambio.nordinvestimentos.com.br'
      : 'https://onboarding-nord-stag.transferbankfx.com.br',
    institution: 'NORD',
    key: 'NORD',
    tag: 'NOR',
    color: '#71c8d1',
    isApp: true
  },
  MPDI: {
    platformUrlRedirection: isProduction
      ? 'https://admin.mapacambio.com.br'
      : 'https://admin-mpdi-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://admin.mapacambio.com.br',
      'https://admin-mpdi-stag.transferbankfx.com.br',
      'https://admin-mpdi.transferbankfx.com.br'
    ],
    platformOnboardingUrl: isProduction
      ? 'https://onboarding.mapacambio.com.br'
      : 'https://onboarding-mpdi-stag.transferbankfx.com.br',
    institution: 'MPDI',
    key: 'MPDI',
    tag: 'MPDI',
    color: '#001231',
    isApp: true
  },
  OKEGEN: {
    platformUrlRedirection: isProduction
      ? 'https://admin.okegen.com.br'
      : 'https://admin-okegen-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://admin.okegen.com.br',
      'https://admin-okegen-stag.transferbankfx.com.br',
      'https://admin-okegen.transferbankfx.com.br'
    ],
    platformOnboardingUrl: isProduction
      ? 'https://onboarding.okegen.com.br'
      : 'https://onboarding-okegen-stag.transferbankfx.com.br',
    institution: 'OKEGEN',
    key: 'OKEGEN',
    tag: 'OKEGEN',
    color: '#1C4C80',
    isApp: true
  },
  TPAY: {
    platformUrlRedirection: isProduction
      ? 'https://admin.transferpay.exchange'
      : 'https://admin-tpay-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://admin.transferpay.exchange',
      'https://admin-tpay-stag.transferbankfx.com.br'
    ],
    platformOnboardingUrl: isProduction
      ? 'https://onboarding.transferpay.exchange'
      : 'https://onboarding-tpay-stag.transferbankfx.com.br',
    institution: 'TPAY',
    key: 'TPAY',
    tag: 'TPAY',
    color: '#148044'
  },
  BRDESK: {
    platformUrlRedirection: isProduction
      ? 'https://admin.brasildeskcorporate.com.br/'
      : 'https://admin-brdesk-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://admin.brasildeskcorporate.com.br/',
      'https://admin-brdesk-stag.transferbankfx.com.br'
    ],
    platformOnboardingUrl: isProduction
      ? 'https://onboarding.brasildeskcorporate.com.br'
      : 'https://onboarding-brdesk-stag.transferbankfx.com.br',
    institution: 'BRDESK',
    key: 'BRDESK',
    tag: 'BRDESK',
    color: '#718055'
  },
  BRUDER: {
    platformUrlRedirection: isProduction
      ? 'https://admin.brudercambio.com.br/'
      : 'https://admin-bruder-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://admin.brudercambio.com.br/',
      'https://admin-bruder-stag.transferbankfx.com.br'
    ],
    platformOnboardingUrl: isProduction
      ? 'https://onboarding.brudercambio.com.br'
      : 'https://onboarding-bruder-stag.transferbankfx.com.br',
    institution: 'BRUDER',
    key: 'BRUDER',
    tag: 'BRUDER',
    color: '#01836D'
  }
}

export const getPlatformFromUrl = () => {
  const currentUrl = window.location.href
  for (const key in configs) {
    if (configs[key].acceptedUrls.some((url) => currentUrl.includes(url))) {
      document.documentElement.style.setProperty('--button-background', configs[key].color)
      document.documentElement.style.setProperty('--secondary-color', configs[key].color)
      document.documentElement.style.setProperty('--button-color', setTextColor(configs[key].color))
      return configs[key].key
    }
  }
  return configs['TRANSFERBANK'].key
}

const hexToRgb = (hex) => {
  let r = 0,
    g = 0,
    b = 0
  if (hex.length == 4) {
    r = parseInt(hex[1] + hex[1], 16)
    g = parseInt(hex[2] + hex[2], 16)
    b = parseInt(hex[3] + hex[3], 16)
  } else if (hex.length == 7) {
    r = parseInt(hex[1] + hex[2], 16)
    g = parseInt(hex[3] + hex[4], 16)
    b = parseInt(hex[5] + hex[6], 16)
  }
  return [r, g, b]
}

const calculateLuminance = (r, g, b) => {
  const a = [r, g, b].map(function (v) {
    v /= 255
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
  })
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722
}

const setTextColor = (hexColor) => {
  const [r, g, b] = hexToRgb(hexColor)
  const luminance = calculateLuminance(r, g, b)
  return luminance > 0.363 ? '#000000' : '#ffffff'
}

export const platformWhiteLabel = (role, direction) => {
  return configs[role]?.[direction]
}

export const isIncorrectUrlForRole = (role) => {
  const currentUrl = window.location.href
  const acceptedUrls = Object.values(configs)
    .filter((config) => config.institution === role)
    .flatMap((config) => config.acceptedUrls)
  return !acceptedUrls.some((url) => currentUrl.includes(url))
}

export const isTransferbankAdminUser = () => {
  return useAuthToken().getInstitution === 'TRANSFERBANK'
}

export const isDouradaAdminUser = () => {
  return useAuthToken().getInstitution === 'DOURADA'
}

export const hasInputAllowed = () => {
  const { hasInputAllowed } = usePermissions()
  return hasInputAllowed() || isDouradaAdminUser()
}

export const hasSensitiveInputAllowed = () => {
  const { hasSensitiveInputAllowed } = usePermissions()
  return hasSensitiveInputAllowed()
}
